import IframeVideo from "./../components/iframe-video/presenter/iframe-video.js";

const videoContainerElement = document.querySelector(`.video-responsive`);

if (videoContainerElement) {
  const videoUrl = videoContainerElement.dataset.videoUrl;
  const iframeVideoComponent = new IframeVideo(videoContainerElement, videoUrl);

  iframeVideoComponent.init();
}

